module.exports = __webpack_public_path__ + "static/Deklaracja_CE_EN_517-101d4abdde523671b04cd9f27b5e8858.pdf";